import { render, staticRenderFns } from "./page-title.vue?vue&type=template&id=dc73800a&scoped=true"
import script from "./page-title.vue?vue&type=script&lang=js"
export * from "./page-title.vue?vue&type=script&lang=js"
import style0 from "./page-title.vue?vue&type=style&index=0&id=dc73800a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc73800a",
  null
  
)

export default component.exports